import { Review } from "@/types/types";
import axios from "axios";

const API_BASE_URL = process.env.NEXT_PUBLIC_URL + "/api";

export async function saveReview(review: Partial<Review>) {
  try {
    const response = await axios.post(`${API_BASE_URL}/reviews`, review);
    return response.data; // or handle the response as needed
  } catch (error) {
    console.error("Error saving review:", error);
    throw error;
  }
}

export async function fetchReviews(menu: string) {
  try {
    const response = await axios.get(`${API_BASE_URL}/reviews`, {
      params: { menu },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching reviews:", error);
    throw error;
  }
}
